var render, staticRenderFns
import script from "./verticalVideoList.vue?vue&type=script&lang=js&"
export * from "./verticalVideoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\scratch\\runner\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ee110288', component.options)
    } else {
      api.reload('ee110288', component.options)
    }
    
  }
}
component.options.__file = "pandosites.web/mvc/scripts/Controls/ContentBuilder/verticalVideoList.vue"
export default component.exports